import {
  ReceiveReward,
  ReceiveRewards,
  postGetActivityDetails,
  postReceiveVipLevelUpReward,
  postUseGiftCode,
} from "@/api/clientApi/activity";
import { reqGetGameList } from "@/api/clientApi/front";
import { toast } from "@/components/Base/Toaster/Toaster";
import { DialogType } from "@/components/Dialogs/types";
import { useDialog } from "@/components/Dialogs/useDialog";
import {
  NormalActList,
  VipActList,
  newComerActList,
} from "@/constants/constants";
import { RepeatActivity } from "@/enum/activity";
import { useBounsCenterInit } from "@/hooks/bonusCenter/useBounsCenterInit.ts";
import { useClick } from "@/hooks/useClick.ts";
import { useRouter } from "@/hooks/useRouter";
import { getLocale, t } from "@/i18n";
import { formatDate } from "@/lib/dateUtils";
import { debounce } from "@/lib/generalUtils";
import { useTimestampInSeconds } from "@/lib/hooks/useTimestamp";
import { isMobile } from "@/lib/isMobile";
import { routerUtils } from "@/lib/routerUtils";
import { sdkManager } from "@/lib/sdk/sdkManager";
import { renderInnerHtml } from "@/lib/utils";
import { doActivityFailed } from "@/stores/activityStore";
import {
  bonusCenterStore,
  changeTabIndex,
  getSpecialActivityRewards,
  tabList,
  togglesSpecialDetail,
} from "@/stores/bonusCenterStore";
import { getProviderByGplat } from "@/stores/gameStore";
import { KYCStore } from "@/stores/kycStore";
import { sysConfigStore } from "@/stores/sysConfigStore.ts";
import { getUserInfo } from "@/stores/userStore";
import { ActivityReward } from "@/types/activity";
import {
  ActivityDetailStatus,
  ActivityTypeEnum,
  UserKycAuthActionType,
} from "@/types/compontent/base/baseEnum";
import { GameNode } from "@/types/swagger/front";
import { ReceiveRewardsReq, Reward } from "@/types/swagger/reward";
import { SpecialActivityRewards } from "@/types/swaggerex/activity";

export const useBonusCenter = () => {
  const { push, preCheckEnterGame } = useRouter();
  const { showDialog, operateDialog } = useDialog();
  const { click } = useClick();

  const reportBonusClick = (atype: number) => {
    const { name, index } = getTabNameAndIndex(atype) || { name: "", index: 0 };
    sdkManager.tdReportEvent("reward_center_activity_click", {
      tab_name: name,
      tab_position_index: index,
      activity_id: atype,
      activity_index: getActivityTabIndex(atype),
    });
    // if (NormalActList.includes(atype)) {
    //   sdkManager.tdReportEvent("general_activity_click", {
    //     [`${atype}_click`]: atype,
    //   });
    // } else if (VipActList.includes(atype)) {
    //   sdkManager.tdReportEvent("vip_activity_click", {
    //     [`${atype}_click`]: atype,
    //   });
    // } else if (newComerActList.includes(atype)) {
    //   sdkManager.tdReportEvent("new_user_activity_click", {
    //     [`${atype}_click`]: atype,
    //   });
    // }
  };
  const reportBonusTabClick = (index: number) => {
    sdkManager.tdReportEvent("reward_center_tab_click", {
      tab_position_index: index,
      tab_name: getTabName(index),
    });
  };
  const getTabName = (index: number) => {
    if (index === 0) {
      return "newcomer";
    } else if (index === 1) {
      return "general";
    } else if (index === 2) {
      return "vip";
    } else if (index === 3) {
      return "special";
    }
    return "";
  };

  const getTabNameAndIndex = (atype: number) => {
    if (NormalActList.includes(atype)) {
      return { name: "general", index: 1 };
    } else if (VipActList.includes(atype)) {
      return { name: "vip", index: 2 };
    } else if (newComerActList.includes(atype)) {
      return { name: "newcomer", index: 0 };
    } else {
      return { name: "special", index: 3 };
    }
  };
  const getActivityTabIndex = (atype: number) => {
    const vipAct = Object.values(bonusCenterStore.bonusCenterCardData)
      .filter((item) => VipActList.includes(item.atype) && item.hide !== true)
      .sort((a, b) => a.order - b.order);
    const normalAct = Object.values(bonusCenterStore.bonusCenterCardData)
      .filter(
        (item) => NormalActList.includes(item.atype) && item.hide !== true,
      )
      .sort((a, b) => a.order - b.order);
    const newComerAct = Object.values(bonusCenterStore.bonusCenterCardData)
      .filter(
        (item) => newComerActList.includes(item.atype) && item.hide !== true,
      )
      .sort((a, b) => a.order - b.order);
    if (vipAct.find((item) => item.atype === atype)) {
      return vipAct.findIndex((item) => item.atype === atype);
    } else if (normalAct.find((item) => item.atype === atype)) {
      return normalAct.findIndex((item) => item.atype === atype);
    } else if (newComerAct.find((item) => item.atype === atype)) {
      return newComerAct.findIndex((item) => item.atype === atype);
    } else {
      return -1;
    }
  };

  const handleBonusClick = (
    atype: number,
    cardClick: boolean = false,
    id?: string,
  ) => {
    reportBonusClick(atype);
    const locale = getLocale();
    //竞标赛
    if (!id && atype == RepeatActivity.RepeatCompetition) {
      push("/tournament");
      return;
    }

    switch (atype) {
      // case ActivityTypeEnum.newCheckIn:
      //   // 救济金3
      //   showDialog({ type: DialogType.NewCheckIn });

      //   break;
      // case ActivityTypeEnum.newbieWheel:
      //   // 新人转盘
      //   showDialog({ type: DialogType.NewbieWheel });
      //   break;
      // case ActivityTypeEnum.reliefFund3:
      //   // 日亏损返现
      //   showDialog({ type: DialogType.FreeRelief });
      //
      //   break;
      // case ActivityTypeEnum.superValueGiftBox:
      // 超级价值礼包 新人礼包
      // showDialog({ type: DialogType.SuperValueGift });

      // break;
      // case ActivityTypeEnum.gachapon:
      //   // 扭蛋活动
      //   showDialog({ type: DialogType.GachaActivity });
      //   break;
      case ActivityTypeEnum.propsItem:
        // 道具
        showDialog({ type: DialogType.PropsList });

        break;
      case ActivityTypeEnum.wagerContest: {
        const from = bonusCenterStore.bonusCenterCardData[atype];
        if (from.status == ActivityDetailStatus.canReceive && !cardClick) {
          receiveRewards(from.other.aTypes, from.other.rankingBonus);
        } else {
          push("/wager-contest");
        }

        break;
      }

      case ActivityTypeEnum.appdownload: {
        const from = bonusCenterStore.bonusCenterCardData[atype];
        if (from.status == ActivityDetailStatus.canReceive) {
          receiveReward(from.atype, from.rewards?.list?.[0]?.id);
        } else {
          push("/install");
        }
        break;
      }
      // 七日新手任务 首充活动 幸运转盘
      case ActivityTypeEnum.superValueGiftBox:
      case ActivityTypeEnum.reliefFund3:
      case ActivityTypeEnum.newCheckIn:
      case ActivityTypeEnum.dailyCashbackExperience:
      case ActivityTypeEnum.sevenNewTask:
      case ActivityTypeEnum.firstDeposit:
      case ActivityTypeEnum.cashFlop:
      case ActivityTypeEnum.roulette:
      case ActivityTypeEnum.gachapon:
      case ActivityTypeEnum.newbieWheel: {
        const from = bonusCenterStore.bonusCenterCardData[atype];
        if (from.details_status?.new_status !== ActivityDetailStatus.Locked) {
          showDialog({
            type: DialogType.ActivityIframe,
            data: { atype: atype },
          });
        }
        break;
      }
      case ActivityTypeEnum.shakeRedPacket:
      case ActivityTypeEnum.dailyLossBack:
      case ActivityTypeEnum.vipWeeklyCard:
      case ActivityTypeEnum.flipCard:
        showDialog({
          type: DialogType.ActivityIframe,
          data: { atype: atype, source: "bonus-center" },
        });
        break;
      case ActivityTypeEnum.vipDayDeposit: {
        const from = bonusCenterStore.bonusCenterCardData[atype];
        if (from.status == ActivityDetailStatus.canComplete) {
          push("/deposit");
        } else {
          receiveReward(atype, id);
        }
        break;
      }

      // 309/310改为不推送道具, 从接口返回获取, 其他应该没有道具和钱一起返回 2025/08/08
      default:
        receiveReward(atype, id);

        break;
    }
  };

  const handleRuleClick = (atype: number) => {
    if (atype == ActivityTypeEnum.wagerContest) {
      push(`/wager-contest`);
    } else {
      showDialog({
        type: DialogType.Rule,
        data: {
          atype: atype,
        },
      });
    }
  };

  const receiveRewards = async (atypes: number[], point: number) => {
    const res = await ReceiveRewards({
      activity_types: atypes,
    } as ReceiveRewardsReq);

    if (res) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const fail_data = res.fail_datas.find((el: any) => !el.ok);
      if (fail_data) {
        //领取失败

        doActivityFailed(fail_data, click);
        return;
      }
      postGetActivityDetails({ atypes: atypes });
      if (point) {
        getUserInfo();
        showDialog({
          type: DialogType.Reward,
          data: { items: [{ point: point }] },
        });
      } else {
        toast.success(t("tips.receive_success"));
      }
    }
  };

  const toSpecialGame = async (mode: number, list: number[]) => {
    if (mode == 2) {
      const gamelist = await reqGetGameList();
      let game_id = 0;
      for (const key in list) {
        game_id =
          gamelist.list?.find((el: GameNode) => el.game_id == list[key])
            ?.game_id || 0;
        if (game_id) {
          break;
        }
      }
      const pass = await preCheckEnterGame({
        gid: `${game_id}`,
      });

      if (!pass) {
        return;
      }
      const defaultSportGameId = sysConfigStore.sport_config.sport_game_id;
      if (Number(game_id) === Number(defaultSportGameId)) {
        push(`/sports/${game_id}`);
        return;
      }
      push(`/game/${game_id}`);
    } else if (mode == 1) {
      routerUtils.toCasino(list.length > 0 ? list[0] : 0);
    } else if (mode == 3) {
      if (list.length > 0) {
        const tag = getProviderByGplat(sysConfigStore, list[0]);
        if (tag) {
          push("/providers/" + tag?.tag);
        } else {
          push("/casino");
        }
      }
    } else {
      push("/");
    }
  };
  const receiveReward = async (
    atype: number,
    id?: string,
    is_cond_reward = false,
    callback?: () => void,
  ) => {
    const from = bonusCenterStore.bonusCenterCardData[atype] || {};
    const item = from.rewards?.list?.[0] || null;
    id = id || item?.id || "";
    is_cond_reward = item?.is_cond_reward || false;
    if (!id && !item) {
      if (from.status == ActivityDetailStatus.toReceive) {
        push(`/bonus-center`);
      } else {
        push(`/vip`);
      }
      return;
    }

    let vip_level = 0;
    if (!id) {
      if (from.rewards?.list) {
        const item = from?.rewards?.list?.[0] || {};
        id = item.id;
        vip_level = item.vip_level;
        is_cond_reward = item?.is_cond_reward;
      }
    } else {
      const item = from?.rewards?.list.find((el: Reward) => el.id == id);
      if (item) {
        vip_level = item.vip_level;
      }
    }
    if (id) {
      const reward = from.rewards.list.find((el: Reward) => el.id == id);
      const point = reward?.point || 0;
      const props = reward?.props || [];
      const code = reward?.code || 0;
      const wallet_type = reward?.wallet_type;
      const tips = receiveRewardFailed(item); // 判断是否满足领取条件
      if (tips) {
        return;
      }
      if (atype == ActivityTypeEnum.vipUpgrade) {
        const res = await postReceiveVipLevelUpReward({
          activity_type: ActivityTypeEnum.vipUpgrade,
          is_cond_reward,
          reward_id: id,
          vip_level,
        });
        if (res) {
          postGetActivityDetails({ atypes: [atype] });
          let arr = [];
          if (point) {
            getUserInfo();
            arr.push({
              walletType: wallet_type || 0,
              point: point,
            });
          }
          if (props) {
            arr = [...arr, ...props].map((item) => {
              if (item?.item_lang) {
                item.item_lang = JSON.parse(item.item_lang);
              }
              return {
                ...item,
              };
            });
          }
          if (arr.length > 0) {
            const { showDialog } = useDialog();
            showDialog({ type: DialogType.Reward, data: { items: arr } });
          }
          // useHomeStore().openGoldPopup();
          // res.wallet_type = reward.wallet_type;
          // res.code = reward.code;
          // useAppStore().openFissionPopup(res);
        }
        // (res: any) => {
        //   useUserStore().getDetailsV2([atype]);
        //   useHomeStore().openGoldPopup();
        //   res.wallet_type = reward.wallet_type;
        //   res.code = reward.code;
        //   useAppStore().openFissionPopup(res);
        // },
      } else {
        const res = await ReceiveReward({
          reward_id: id,
          is_cond_reward: !!is_cond_reward,
        });
        if (res) {
          if (point) {
            getUserInfo();
            showDialog({
              type: DialogType.Reward,
              data: {
                items: [{ point: point, walletType: wallet_type || 0 }],
              },
            });
          }
          postGetActivityDetails({ atypes: [atype] });
          callback?.();
        }
      }
    }
  };

  const clickSpecialButton = async (item: SpecialActivityRewards) => {
    const { getPropsItemData } = useBounsCenterInit();
    if (item.is_receivable) {
      const res = await ReceiveReward({
        is_cond_reward: item.is_cond_reward,
        reward_id: item.id,
      });
      if (res) {
        let arr = []; //如果有现金或者彩金 先塞入 道具等推送
        if (item.point) {
          getUserInfo();
          arr.push({
            walletType: item.wallet_type || 0,
            point: item.point,
          });
        }
        if (item?.props && Array.isArray(item?.props)) {
          /* tslint:disable */
          /* eslint-disable */
          arr = [...arr, ...item?.props].map((innerItem) => {
            let lang = innerItem?.item_lang;
            if (lang) lang = JSON.parse(innerItem?.item_lang);
            return {
              ...innerItem,
              item_lang: lang,
            };
          });
          getPropsItemData(true);
        }
        if (arr.length > 0) {
          const { showDialog } = useDialog();
          showDialog({ type: DialogType.Reward, data: { items: arr } });
        }
      }
      getSpecialActivityRewards();
    } else {
      togglesSpecialDetail(item);
    }
  };

  const receiveRewardFailed = (reward: ActivityReward) => {
    if (reward.is_cond_reward || reward.receivable_at) {
      const reward_recv_cond = reward.reward_recv_cond || {};
      let content = "";
      let tipText = "";
      let confirmText = "";
      let cancelText = "";
      let clickTo = 0;
      const textSize = isMobile() ? "text-[12px]" : "text-[14px]";
      const currentTimestamp = useTimestampInSeconds();
      if (
        reward_recv_cond.dis_reward_need_app &&
        reward_recv_cond.dis_reward_need_app.length &&
        !reward_recv_cond.hit_dis_reward_client
      ) {
        clickTo = 1;
        content = t("common.go_app_claim");
        confirmText = t("common.install_app");
      } else if (
        (reward_recv_cond.bind_phone && !reward_recv_cond.hit_bind_phone) ||
        (reward_recv_cond.bind_email && !reward_recv_cond.hit_bind_email) ||
        (reward_recv_cond.bind_withdraw_card &&
          !reward_recv_cond.hit_bind_withdraw_card) ||
        (reward_recv_cond.bind_kyc && !reward_recv_cond.hit_bind_kyc)
      ) {
        clickTo = 2;
        content = t("common.complete_settings");
        confirmText = t("common.go_bind");
        cancelText = t("common.cancel");
        if (reward_recv_cond.bind_phone && !reward_recv_cond.hit_bind_phone) {
          tipText += "• " + t("common.phone_ver") + "\n";
        }
        if (reward_recv_cond.bind_email && !reward_recv_cond.hit_bind_email) {
          tipText += "• " + t("common.email_ver") + "\n";
        }
        if (
          reward_recv_cond.bind_withdraw_card &&
          !reward_recv_cond.hit_bind_withdraw_card
        ) {
          clickTo = 3;
          tipText += "• " + t("common.bind_bank_claim") + "\n";
        }
        if (reward_recv_cond.bind_kyc && !reward_recv_cond.hit_bind_kyc) {
          tipText += "• " + t("settings.kyc_verification") + "\n";
        }
        if (
          reward_recv_cond.hit_bind_phone &&
          reward_recv_cond.hit_bind_email &&
          reward_recv_cond.bind_kyc &&
          !reward_recv_cond.hit_bind_kyc
        ) {
          clickTo = 4;
        }
      } else if (
        reward.receivable_at &&
        reward.receivable_at > currentTimestamp()
      ) {
        content = t("common.claim_after", {
          val: formatDate(reward.receivable_at),
        });
        confirmText = t("common.got_it");
      }

      if (clickTo) {
        showDialog({
          type: DialogType.Tips,
          data: {
            title: t("common.tips"),
            content: `<div class="text-general-light text-[14px]">${content}<div class="text-general-bright mt-[8px] ${textSize} text-left">${renderInnerHtml(tipText)}</div></div>`,
            confirmText: confirmText,
            cancelText: cancelText,
            onConfirm: () => {
              // -- 在活动页触发校验时，隐藏活动弹框
              operateDialog("ActivityIframe");
              switch (clickTo) {
                case 1:
                  push("/install");
                  break;
                case 2:
                  push("/settings?tab=security");
                  break;
                case 3:
                  push("/wallet/bankcard");
                  break;
                case 4:
                  KYCStore.getUserKycAuthByAction(UserKycAuthActionType.bet);
                  break;
                default:
                  break;
              }
            },
          },
        });
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const useGiftCode = async (code: string) => {
    if (!code) {
      code = bonusCenterStore.redeem_code;
      return;
    }
    const res = await postUseGiftCode({ code });
    if (res) {
      if (res && res.reward) {
        const arr = [
          ...(res?.reward?.point && res?.reward?.point > 0
            ? [
                {
                  point: res?.reward?.point,
                  walletType: res?.reward?.wallet_type,
                },
              ]
            : []),
          ...(res?.reward?.props || []),
        ].map((item) => {
          if (item?.item_lang) item.item_lang = JSON.parse(item.item_lang);
          return {
            ...item,
          };
        });
        useBounsCenterInit().initData();
        showDialog({
          type: DialogType.Reward,
          data: {
            items: arr,
          },
        });
      }
      bonusCenterStore.redeem_code = "";
    }
  };

  const debouncedCheckTab = debounce(
    (list: { index: number }[], userTab: string | string[] | undefined) => {
      if (list.length > 0) {
        if (userTab !== undefined) {
          const tabNum = Number(userTab);
          // 判定tabNum是否在list中
          const userTabExists = list.some((item) => item.index === tabNum);
          if (userTabExists) {
            changeTabIndex(tabNum);
          } else {
            changeTabIndex(list[0].index);
          }
        }
      }
    },
    150,
  );

  return {
    handleBonusClick,
    reportBonusTabClick,
    handleRuleClick,
    clickSpecialButton,
    toSpecialGame,
    useGiftCode,
    receiveReward,
    receiveRewardFailed,
    debouncedCheckTab,
  };
};
